import { storageService } from './storageService';
import { axiosService } from './axiosService';

export class AuthService {
  authSuccess = ({ accessToken, admin }: any = {}) => {
    if (accessToken) storageService.set('accessToken', accessToken);
    if (admin) {
      if (admin.name) storageService.set('name', admin.name);
      if (admin.email) storageService.set('email', admin.email);
      if (admin.role) storageService.set('role', admin.role);
      // Empty array = full access. Stored as JSON so the dashboard can scope tabs/metrics.
      if (Array.isArray(admin.allowedProducts)) {
        storageService.set('allowedProducts', JSON.stringify(admin.allowedProducts));
      }
    }
  };

  signOut = () => {
    storageService.remove('accessToken');
    storageService.remove('name');
    storageService.remove('email');
    storageService.remove('role');
    storageService.remove('allowedProducts');
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  };

  login = async ({ email, password }: { email: string; password: string }) => {
    try {
      const { data: response }: any = await axiosService
        .withoutToken()
        .post('user/system-admin/login', { email, password });
      return response;
    } catch (error: any) {
      console.error('Admin login failed!', error);
      const message =
        (error && error.response && error.response.data && error.response.data.message) ||
        'Login failed. Please try again.';
      return { error: true, message };
    }
  };

  get isLoggedIn() {
    const token = storageService.get('accessToken');
    return !!token;
  }

  get userName() {
    return storageService.get('name');
  }

  get userEmail() {
    return storageService.get('email');
  }

  get userRole() {
    return storageService.get('role');
  }

  // Products this admin may access. Empty array = full access (all products).
  get allowedProducts(): string[] {
    try {
      const raw = storageService.get('allowedProducts');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  // Full access when there is no restriction list.
  get isFullAccess(): boolean {
    return this.allowedProducts.length === 0;
  }

  hasProduct = (product: string): boolean => {
    return this.isFullAccess || this.allowedProducts.indexOf(product) !== -1;
  };
}

const authServiceInstance = new AuthService();
export { authServiceInstance as authService };
